import { render, staticRenderFns } from "./ShelfTasks.vue?vue&type=template&id=3a6c03e1&scoped=true&"
import script from "./ShelfTasks.vue?vue&type=script&lang=js&"
export * from "./ShelfTasks.vue?vue&type=script&lang=js&"
import style0 from "./ShelfTasks.vue?vue&type=style&index=0&id=3a6c03e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c03e1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6c03e1')) {
      api.createRecord('3a6c03e1', component.options)
    } else {
      api.reload('3a6c03e1', component.options)
    }
    module.hot.accept("./ShelfTasks.vue?vue&type=template&id=3a6c03e1&scoped=true&", function () {
      api.rerender('3a6c03e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/ShelfTasks.vue"
export default component.exports